import React from "react";
import { Link } from "react-router-dom";
import { FiAlertTriangle, FiRefreshCw, FiHome } from "react-icons/fi";
import "./ErrorBoundary.scss";

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("[ErrorBoundary]", error, errorInfo);

        // Enviar a GTM/Analytics para tracking
        if (typeof window !== "undefined" && window.dataLayer) {
            window.dataLayer.push({
                event: "app_error",
                error_message: String(error?.message || error),
                error_location: window.location.pathname,
            });
        }
    }

    handleReload = () => {
        this.setState({ hasError: false, error: null });
        window.location.reload();
    };

    handleReset = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-boundary-page">
                    <div className="error-boundary-card">
                        <div className="error-boundary-icon">
                            <FiAlertTriangle />
                        </div>
                        <h1 className="error-boundary-title">Algo salió mal</h1>
                        <p className="error-boundary-description">
                            Ocurrió un error inesperado. Intenta recargar la página o vuelve al inicio.
                        </p>
                        {process.env.NODE_ENV !== "production" && this.state.error && (
                            <pre className="error-boundary-details">
                                {String(this.state.error?.message || this.state.error)}
                            </pre>
                        )}
                        <div className="error-boundary-actions">
                            <button onClick={this.handleReload} className="error-boundary-btn primary">
                                <FiRefreshCw /> Recargar página
                            </button>
                            <Link to="/" onClick={this.handleReset} className="error-boundary-btn secondary">
                                <FiHome /> Ir al inicio
                            </Link>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
